const deepLinkCache = new Map();

// creative is an optional trailing arg (SEOENG-38): a paid landing visit maps the ad's utm_term
// onto the Adjust creative slot.
export const generateAdjustDeepLink = async (
  campaign, isOrganic, path, label, title, description, platform, channel, adgroup, creative
) => {
  const cacheKey = JSON.stringify({ campaign, isOrganic, path, label, title, description, platform, channel, adgroup, creative });

  if (deepLinkCache.has(cacheKey)) {
    return deepLinkCache.get(cacheKey);
  }

  const promise = _fetchAdjustDeepLink(campaign, isOrganic, path, label, title, description, platform, channel, adgroup, creative);
  deepLinkCache.set(cacheKey, promise);

  promise.catch(() => {
    deepLinkCache.delete(cacheKey);
  });

  return promise;
};

const _fetchAdjustDeepLink = async (
  campaign, isOrganic, path, label, title, description, platform, channel, adgroup, creative
) => {
  const requestBody = {
      campaign: campaign,
      is_organic: isOrganic,
      use_shorten_url: 1,
      deep_link_path: path,
      label: label,
      og_title: title,
      og_description: description,
      ...(channel && { channel }),
      ...(adgroup && { adgroup }),
      ...(creative && { creative }),
      og_image: platform === "gti" 
          ? "https://static-resources-gotradeindo.s3.ap-southeast-3.amazonaws.com/icons/gotradeindo-app-logo.webp" 
          : "https://files-tr8.s3.ap-southeast-1.amazonaws.com/icons/gotrade-app-logo.webp",
  };

  try {
      const baseUrl = platform === "gti"
        ? process.env.GATSBY_ID_API_URL
        : process.env.GATSBY_API_URL;
      const url = `${baseUrl}/api/adjust-generateDeeplink`;
      const response = await fetch(url, {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const responseData = await response.json();

      return responseData.url || null;
  } catch (error) {
      console.error("Error generating Adjust referral link:", error);
      return null;
  }
};


export const generateCampaignDeeplink = async (platform = 'gti') => {
    const urlParams = new URLSearchParams(window.location.search);
    const utmSource = urlParams.get('utm_source') || '';
    const utmMedium = urlParams.get('utm_medium') || '';
    const utmCampaign = urlParams.get('utm_campaign') || '';
    const utmContent = urlParams.get('utm_content') || '';
    const utmTerm = urlParams.get('utm_term') || '';
    
    const deepLinkPath = `splash&utm_source=${utmSource}&utm_campaign=${utmCampaign}&utm_medium=${utmMedium}&utm_content=${utmContent}&utm_term=${utmTerm}`;

    if (!utmSource) return null;

    const title = platform === 'gti'
        ? "Gotrade Indonesia | Download Aplikasi"
        : "Gotrade | Download App";
    const description = platform === 'gti'
        ? "Mulai Investasi di Gotrade, aplikasi investasi saham luar negeri. Mulai dari Rp 15 Ribu!"
        : "Invest in US stocks, starting from $1.";

    const adjustLink = await generateAdjustDeepLink(
        utmSource,
        true,
        deepLinkPath,
        null,
        title,
        description,
        platform,
    );

    return adjustLink;
};